import React from "react";
import { PROFILE, NAV } from "@/data/content";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-neutral-800 py-12" data-testid="site-footer">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <button
            onClick={() => scrollTo("hero")}
            className="font-heading text-3xl tracking-tight text-white hover:text-volt transition-colors"
            data-testid="footer-logo"
          >
            KUSUM SHAIKH<span className="text-volt">.</span>
          </button>
          <nav className="flex flex-wrap gap-6 items-center">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => scrollTo(n.id)}
                className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-volt transition-colors"
                data-testid={`footer-link-${n.id}`}
              >
                {n.label}
              </button>
            ))}
            <a
              href={PROFILE.cvUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="font-mono text-xs uppercase tracking-[0.2em] text-volt hover:text-white transition-colors"
              data-testid="footer-download-cv"
            >
              Download CV
            </a>
          </nav>
        </div>
        <div className="mt-10 pt-6 border-t border-neutral-900 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-mono text-[11px] uppercase tracking-wide text-neutral-600">
            © {new Date().getFullYear()} {PROFILE.fullName} · Football Coach · {PROFILE.location}
          </p>
          <p className="font-mono text-[11px] uppercase tracking-wide text-neutral-600">
            {PROFILE.email} · {PROFILE.social}
          </p>
        </div>
      </div>
    </footer>
  );
}
